import { domain } from 'modules/data';
import { sortReferencesWithNesting } from 'shared/helpers';

export type QBooksClass = domain.QBooksContext['classes'][number] & { nestingLevel?: number };

export const getClassesWithNesting = (classes: domain.QBooksContext['classes']): QBooksClass[] => {
    return sortReferencesWithNesting(classes);
};
